import * as React from "react";
import { GRAPHQL_TYPE_PERSON, Person as GraphqlPerson } from "@radivision/graphql/lib/ts/graphql/person";
import { Router } from "../../utilities/router";
import { SVG } from "../../component-configuration/svgs";
import CS from "../../../static/ComingSoon.png";
import { getProfileInfo } from "../../utilities/get-profile-info";
import { AUTH_SIGNIN, AUTH_SIGNUP, AUTHENTICATION_MODAL_ID } from "../../redux/authentication/constants";
import { store } from "../../redux";
import { setAuthState } from "../../redux/actions";

interface Props {
  hideNavigation: boolean,
  user: GraphqlPerson,
  activePage: string,
  handleClick: any,
}

const NavBarExclusive = ({ hideNavigation, user, activePage, handleClick } : Props) => {
  return (
    <ul className="navbar-nav ml-auto">
      {/* <li className="nav-item">
        <a
          className={`nav-link${activePage === "home" ? " active" : ""}`}
          onClick={(event: React.MouseEvent<HTMLElement>) =>
            handleClick(event, -1, "home", undefined, undefined)
          }
        >
          <span>Home</span>
        </a>
      </li> */}
      {!hideNavigation && (
        <>
          {user ? (
            <li className="nav-item dropdown d-block d-sm-none">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="userDropDownMenuMobile"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                My Profile<i>{SVG.caretRight}</i>
              </a>
              <div className="dropdown-menu" aria-labelledby="userDropDownMenuMobile">
                <a
                  className={`dropdown-item${
                    user !== null &&
                    user !== undefined &&
                    window.location.href === user.landingPageUrl
                      ? " active"
                      : ""
                  }`}
                  onClick={() => {
                    const { profileUrl } = getProfileInfo(user);
                    Router.navigateTo(profileUrl);
                  }}
                >
                  My Profile
                </a>
                {/* <a
              className="dropdown-item companyProfiles collapsable"
              href="#companyProfiles"
              data-expanded="false"
            >
              My Companies
            </a>
            <div
              className="collapse multi-collapse"
              id="companyProfiles"
            >
              <div className="card card-body">
                {user.entities === null ||
                user.entities === undefined
                  ? null
                  : user.entities.map((entity, index) => {
                      return (
                        <a
                          className="dropdown-item"
                          href={entity.landingPageUrl}
                          key={index}
                        >
                          {entity.name}
                        </a>
                      );
                    })}
              </div>
            </div> */}
                <a
                  className={`dropdown-item setting${activePage === "saved" ? " active" : ""}`}
                  href="/saved"
                  onClick={() => Router.to("saved")}
                >
                  My List
                </a>
                <a
                  className={`dropdown-item setting${
                    activePage === "following" ? " active" : ""
                  }`}
                  href="/following"
                  onClick={() => Router.to("following")}
                >
                  Following
                </a>
                <a
                  className={`dropdown-item setting${
                    activePage === "settings" ? " active" : ""
                  }`}
                  href="/account"
                  onClick={() => Router.to("account")}
                >
                  Settings
                </a>
                <a
                  className="dropdown-item signout"
                  onClick={() => {
                    import("../../authentication/cognito-client").then((module) => {
                      return module.CognitoClient.signOut(true);
                    });
                  }}
                >
                  Sign out
                </a>
                {/* <CreateCompanyButton /> */}
              </div>
            </li>
          ) : null}
          <li className="nav-item">
            <a
              className={`nav-link ${activePage === "exclusive-events" ? "active" : ""}`}
              href="exclusive-events"
              onClick={(event: React.MouseEvent<HTMLElement>) =>
                handleClick(event, -1, "exclusive-events", undefined)
              }
            >
              <span className="new-feature-label">Exclusive Events</span>
            </a>
          </li>
        </>
      )}
      {/* user login or join on mobile */}
      {!user ? (
        <div className="xs-user-login d-block d-sm-none">
          <div className="join-btn">
            <a
              href="#"
              className="join"
              data-toggle="modal"
              data-target={`#${AUTHENTICATION_MODAL_ID}`}
              onClick={(e) => {
                e.preventDefault();
                store.dispatch(setAuthState({ step: AUTH_SIGNUP }));
                // toggleNavMenu();
              }}
            >
              Join
            </a>
          </div>
          <div className="login-btn">
            Already have an account?{" "}
            <a
              className="login"
              data-toggle="modal"
              data-target={`#${AUTHENTICATION_MODAL_ID}`}
              onClick={() => {
                // toggleNavMenu();
                store.dispatch(setAuthState({ step: AUTH_SIGNIN }));
              }}
              href="#"
            >
              Log in
            </a>
          </div>
        </div>
      ) : null}
    </ul>
  )
}

export default NavBarExclusive;